var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "sidebar filter-sidebar" }, [
    _c("div", { staticClass: "filter-title js-accordion-title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filter-content js-accordion-content" },
      _vm._l(_vm.filters, function(filter, key, index) {
        return _c("filter-group", {
          key: key,
          attrs: {
            filter: filter,
            index: index,
            specification: filter.specification
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }